import * as React from 'react';
import { Anchor, Box, IBoxComponentProps, IconButton, Label } from '@moosend/mooskin';
import { isClient, isSendUser } from '../../services/common/apiUtils';
import { useSelector } from 'react-redux';
import IStoreState from '../../../../main/src/store/model';
import { HelpCenter } from 'accounts/help';

interface IHelpLinksProps {
	title?: string;
}

export const HelpLinks: React.FC<IHelpLinksProps> = (props) => {
	if (isClient()) {
		return null;
	}

	const localizationState = useSelector((state: IStoreState) => state.accountSettingsReducer.localization);
	const customSettings = useSelector((state: IStoreState) => state.accountSettingsReducer.CustomSettings);

	const sitecoreFaq = customSettings.find((item) => {
		return item.Property === 'sitecore_faq' && item.Value?.toLowerCase() === 'true';
	})
		? true
		: false;
	const language = localizationState?.currentLanguage;
	const helpCenterByType = sitecoreFaq || isSendUser() ? HelpCenter.sitecore : HelpCenter.moosend;
	const helpResources = language && helpCenterByType[language as 'en'] ? helpCenterByType[language as 'en'] : helpCenterByType.en;
	const helpMain = language && helpCenterByType[language as 'en'] ? helpCenterByType[language as 'en'].main : helpCenterByType.en.main;

	const helpDetails =
		Object.values(helpResources).find((item, i) => {
			const foundRoute = item.routes.find((route) => {
				return location.pathname.toLowerCase().includes(route.toLowerCase());
			});

			if (foundRoute) {
				return true;
			}
			return false;
		}) || helpMain;

	let articles = helpDetails.articles.length ? helpDetails.articles : helpDetails.drawerArticles;
	if (window.location.href.indexOf('/campaigns/list/Transactional/') > -1) {
		articles = helpDetails.drawerArticles;
	}
	return (
		<Box d="flex" direction="column" align="center" noRender={['sm', 'xs']}>
			{props.title && (
				<Label mt={60} mb={30} fontWeight={500} fontColor="fontColors.primary2">
					{props.title}
				</Label>
			)}
			<Box maxW={1000} d="flex" flexWrap="wrap">
				{articles.map((item) => {
					return <HelpBox key={item.url} url={item.url} label={item.label} withArrow={item.withArrow} bgColor={item.bgColor} />;
				})}
			</Box>
		</Box>
	);
};

export interface IHelpBox {
	url: string;
	withArrow?: boolean;
	label: string;
	bgColor?: string;
}

const HelpBox: React.FC<IHelpBox> = (props) => {
	return (
		<Box m="0 auto" p={10} w={330} h={120}>
			<Anchor
				borderRadius={3}
				boxShadow="sm"
				bgColor={props.bgColor ? props.bgColor : props.withArrow ? '#f0b941' : 'backgroundColors.white'}
				border="solid 7px"
				borderColor="backgroundColors.gray1"
				px={20}
				d="flex"
				align="center"
				target="_blank"
				textDecoration="none"
				h="100%"
				href={props.url}
			>
				{!props.withArrow ? (
					<IconButton fontColor="#f0b941" mr={15}>
						help
					</IconButton>
				) : null}
				<Label fontSize={14} fontColor={props.withArrow ? 'fontColors.white' : 'fontColors.primary2'}>
					{props.label}
				</Label>
				{props.withArrow ? (
					<IconButton fontColor={props.withArrow ? 'fontColors.white' : 'fontColors.primary2'} ml={20}>
						arrow_forward
					</IconButton>
				) : null}
			</Anchor>
		</Box>
	);
};
